import { stringify } from 'flatted/cjs';
import { Severity } from './error-logger.types';
import { isClientError } from '../definitions/error.types';
export var reasonToString = function (reason) {
    if (!reason) {
        return;
    }
    if (reason instanceof Error) {
        return (reason.name || 'Error') + ": '" + reason.message + "'";
    }
    if (isClientError(reason)) {
        return "Client error: " + reason.code + ". Message: " + reason.message;
    }
    return stringify(reason);
};
export var limit = function (maybeString) {
    var string = String(maybeString);
    return string.slice(0, 900);
};
export var getErrorBiParams = function (error, params) {
    if (params === void 0) { params = {}; }
    return {
        errc: error.id,
        errn: error.name,
        sev: error.level || Severity.ERROR,
        extra: limit(stringify(params.extra)),
        errorMessage: limit(reasonToString(params.reason)),
    };
};
//# sourceMappingURL=utils.js.map